import { bfsUserWebHttp, otmsHttp } from '@/utils/http/index'

/**
 * 账号组织列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9276@param {*} msg 
 */
export function getOrganizationList(msg) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_org/list',
    method: 'post',
    data: msg,
  })
}

/**
 * 获取指定系统的权限清单树
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9262
 */
export function getAdminFunctionTree(data, params) {
  return otmsHttp.post({
    url: '/permission-plus/admin/system/permission/tree',
    method: 'post',
    data,
    params
  })
}
/**
 * 查询账号权限树
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9236
 */
export function getUserFunctionTree(data, params) {
  return otmsHttp.post({
    url: '/permission-plus/account/permission/tree',
    method: 'post',
    data,
    params
  })
}

/**
 * 查询账号按钮权限列表
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9234
 */
export function getUserButtonList(data, params) {
  return otmsHttp.post({
    url: '/permission-plus/account/permission/list',
    method: 'post',
    data,
    params
  })
}

/**
 * 货主账号组织列表
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/11382
 */
export function getAccountOrg(data, params) {
  return otmsHttp.post({
    url: '/customer/account_org/list',
    method: 'post',
    data,
    params
  })
}

/**
 * 查询[账号与身份]列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9274
 */
export function getAccountIdentity(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_identity/list',
    method: 'post',
    data,
    params
  })
}

/**
 * changeExt4Customer
 * https://yapi.ops.yunlizhi.cn/project/18/interface/api/9372
 */
export function getCustomerChange(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-sso/session/customer/change_ext',
    method: 'post',
    data,
    params
  })
}

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function organizationList(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_org/organization/corp_customer_list',
    method: 'post',
    data,
  })
}

/**
 * 查询补货货主数
 */
export function getReplenishmentCustomer(data = {}) {
  return otmsHttp.post('/oms_plus/replenishment/customer/list', data)
}